import React from 'react';
import { motion } from 'framer-motion';
import { Schedule, Weekend } from '@mui/icons-material';

const ContactHours: React.FC = () => {
  const hours = [
    {
      Icon: Schedule,
      title: 'Weekdays',
      items: ['Monday - Friday: 8:00 AM - 5:00 PM']
    },
    {
      Icon: Weekend,
      title: 'Weekends',
      items: ['Saturday: 9:00 AM - 1:00 PM', 'Sunday: Closed']
    }
  ];

  return (
    <section className="py-20 bg-black">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="text-center mb-12"
          >
            <h2 className="text-4xl md:text-5xl font-headline font-bold mb-6" style={{ color: '#EF3F23' }}>
              Office Hours
            </h2>
          </motion.div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {hours.map((block, index) => {
              const Icon = block.Icon;
              return (
                <motion.div
                  key={block.title}
                  initial={{ opacity: 0, y: 24 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  className="relative rounded-xl border border-gray-800 bg-gray-900/50 p-8 hover:border-bizani-orange/50 transition-colors duration-300"
                >
                  <div className="absolute top-0 left-1/2 -translate-x-1/2 w-10 h-0.5 bg-bizani-orange rounded-full opacity-80" />
                  <div className="flex flex-col items-center text-center pt-2">
                    <div className="w-14 h-14 rounded-full bg-bizani-orange/20 flex items-center justify-center mb-4">
                      <Icon style={{ color: '#EF3F23', fontSize: 28 }} />
                    </div>
                    <h3 className="text-xl font-headline font-bold text-white mb-4">{block.title}</h3>
                    <ul className="space-y-2">
                      {block.items.map((item, i) => (
                        <li key={i} className="text-gray-400 font-body text-sm md:text-base">
                          {item}
                        </li>
                      ))}
                    </ul>
                  </div>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactHours;
